import config from '../../config'
import axios from 'axios'

export default {
	state: () => ({
		services: [],
		loading: false,
		error: false
	}),
	mutations: {
		setServices(state, services) {
			state.services = services
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setError(state, error) {
			state.error = error
		}
	},
	actions: {
		fetchServices({commit, state}, force) {
			if (state.services.length === 0 || force === true) {
				commit('setLoading', true);
				commit('setError', false);
				axios.get(config.apiUrl + "/v1/services")
					.then(r => commit('setServices', r.data))
					.then(() => commit('setError', true))
					.then(() => commit('setLoading', false))
			}
		}
	},
	getters: {
		serviceList(state) {
			let r = [];
			for (let v of state.services) {
				r.push({text: v.serviceName, value: v.serviceName});
			}
			return r;
		},
		serviceListAsObjects(state) {
			let r = [];
			for (let v of state.services) {
				r.push({text: v.serviceName, value: v});
			}
			return r;
		},
		serviceListWithAll(state) {
			let r = [];
			r.push({text: "Tous les services", value: "all"});
			for (let v of state.services) {
				r.push({text: v.serviceName, value: v.serviceName});
			}
			return r;
		}
	},
	namespaced: true
}
